import React, { useState } from "react";
import { styled } from '@mui/system';
import Dialog from "@mui/material/Dialog";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { ThemeProvider, createTheme } from '@mui/material/styles'; 
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { TextareaAutosize } from "@mui/material";


const theme = createTheme();

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));

const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));

const EditIncidentDialog = (props) => {
  const [open, setOpen] = React.useState(props.editing);
  const [] = useState(props.name);

  const handleClickOpen = () => {
    formatEmail(legal.toString(), 1);
    formatEmail(cityLead.toString(), 0);
    formatEmail(opsTeam.toString(), 2);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [valid, setValid] = useState(true);
  const [cityLead, setCityLead] = useState(props.emailCityLeader);
  const [legal, setLegal] = useState(props.emailLegal);
  const [opsTeam, setOpsTeam] = useState(props.emailOpsTeam);
  const [errorCityLead, setErrorCity] = useState("none");
  const [errorlLegal, setErrorLegal] = useState("none");
  const [errorOps, setErrorOps] = useState("none");

  const handleCityLeadChange = (e) => {
    setCityLead(e.target.value.replace(/[^a-zA-Z0-9_@., ]/gi, ""));
    validityCheck(e.target.value, 0);
  };

  const validityCheck = (text, type) => {
    var emails = text.replace(/\s/g, "").split(",");

    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    for (var i = 0; i < emails.length; i++) {
      if (emails[i] == "" || !regex.test(emails[i])) {
        if (type == 0) {
          setValid(true);
          setErrorCity("red 2px solid");
        } else if (type == 1) {
          setValid(true);
          setErrorLegal("red 2px solid");
        } else if (type == 2) {
          setValid(true);
          setErrorOps("red 2px solid");
        }
      } else {
        if (type == 0) {
          setValid(false);
          setErrorCity("none");
        } else if (type == 1) {
          setValid(false);
          setErrorLegal("none");
        } else if (type == 2) {
          setValid(false);
          setErrorOps("none");
        }
        if (
          errorCityLead != "none" ||
          (errorOps != "none" && errorlLegal != "none")
        ) {
          setValid(true);
        }
      }
    }
  };

  const formatEmail = (email, type) => {
    var emails = email.replace(/\s/g, "").split(",").join(",\n");
    if (type == 1) {
      setLegal(emails);
    } else if (type == 0) {
      setCityLead(emails);
    } else if (type == 2) {
      setOpsTeam(emails);
    }
  };

  const handleLegalChange = (e) => {
    validityCheck(e.target.value, 1);
    setLegal(e.target.value.replace(/[^a-zA-Z0-9_@., ]/gi, ""));
  };

  const handleOpsTeamChange = (e) => {
    validityCheck(e.target.value, 2);
    setOpsTeam(e.target.value.replace(/[^a-zA-Z0-9_@., ]/gi, ""));
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
      <span
        className="mx-8 text-success text-center"
        style={{
          cursor: "pointer",
          marginLeft: "20px",
        }}
        onClick={handleClickOpen}
      >
        <i className="fas fa-pen"></i>
      </span>
      <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{}}
        >
          <CustomDialogTitle onClose={handleClose}>
            <p className="p-size col-md-10">
            {" "}
            {props.storeType}
            {" >"}
            {props.zone}
            {" >"}
            {props.alertType}
            </p>
          </CustomDialogTitle>
          <CustomDialogContent dividers>
          <label>*Note: Please separate emails using comma (,)</label>
          <form
            className="form-horizontal col-md-12"
            style={{ backgroundColor: "#eaf7fdcc" }}
            onSubmit={(event) => {
              event.preventDefault();

              props.updateUser(props.configId, cityLead, legal, opsTeam);
              setTimeout(() => {
                setOpen(false);
              }, 4000);
            }}
          >
            <div className="form-group">
              <label className="control-label col-sm-2">City Leaders:</label>
              <div className="col-sm-10">
                <TextareaAutosize
                  type="text"
                  className="form-control"
                  name="cityLeader"
                  placeholder="Email for City Leader"
                  value={cityLead}
                  onChange={handleCityLeadChange}
                  style={{ border: errorCityLead, padding: "10px" }}
                  maxLength="1000"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-2"> Legal:</label>
              <div className="col-sm-10">
                <TextareaAutosize
                  type="email"
                  className="form-control"
                  value={legal}
                  onChange={handleLegalChange}
                  placeholder="Email for Legal"
                  style={{ border: errorlLegal, padding: "10px" }}
                  maxLength="1000"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-sm-2"> Operation Head:</label>
              <div className="col-sm-10">
                <TextareaAutosize
                  type="email"
                  className="form-control"
                  value={opsTeam}
                  onChange={handleOpsTeamChange}
                  placeholder="Email for Operation Team"
                  style={{ border: errorOps, padding: "10px" }}
                  maxLength="1000"
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button
                  style={{ marginLeft: "42%", marginTop: "5%" }}
                  onClick={handleClose}
                  type="button"
                  className="btn muted-button  deca-btn-orange a-btn-cancel"
                >
                  Cancel
                </button>

                <button
                  className="btn btn-secondary deca-btn-yellow a-update-email-alert"
                  style={{ marginLeft: "2%", marginTop: "5%" }}
                  disabled={valid}
                >
                  Update Email Alert
                </button>
              </div>
            </div>
          </form>
          </CustomDialogContent>

      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default EditIncidentDialog;
